export class ActionItem {
  constructor(
    public title: string,
    public icon: string,
    public onClick: (data: any) => void,
    public showTitle = false
  ) {}
}
